class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    if (window.rbCartPreview) this.loadPreview();
    if (window.rbCartVariant) this.stampVariant();
  }

  // Cart drawer A/B test (see snippets/cart-drawer.liquid): stamp the cart with the visitor's variant
  // once it has items, so the order carries the attribute _rb_cart_drawer.
  stampVariant() {
    const variant = window.rbCartVariant;
    const stamp = () => {
      if (this.dataset.abVariant === variant || this.stamping) return;
      this.stamping = true;
      fetch(`${routes.cart_update_url}`, {
        ...fetchConfig(),
        ...{ body: JSON.stringify({ attributes: { _rb_cart_drawer: variant } }) },
      })
        .then((response) => {
          if (response.ok) this.dataset.abVariant = variant;
        })
        .catch(() => {})
        .finally(() => {
          this.stamping = false;
        });
    };
    if (Number(this.dataset.cartCount) > 0) stamp();
    subscribe(PUB_SUB_EVENTS.cartUpdate, stamp);
  }

  // Preview switch (?cart_preview=1, see snippets/cart-drawer.liquid): swap in the new drawer for this shopper only.
  loadPreview() {
    const started = Date.now();
    fetch(`${routes.cart_url}?section_id=cart-drawer-haus`)
      .then((response) => response.text())
      .then((responseText) => {
        if (this.renderedAt && this.renderedAt >= started) return;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const source = html.querySelector('#CartDrawer');
        const sourceDrawer = html.querySelector('cart-drawer');
        if (!source || !sourceDrawer) return;
        this.classList.toggle('is-empty', sourceDrawer.classList.contains('is-empty'));
        this.querySelector('#CartDrawer').innerHTML = source.innerHTML;
        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      })
      .catch((e) => {
        console.error(e);
      });
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.renderedAt = Date.now();
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: window.rbCartPreview ? 'cart-drawer-haus' : 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: window.rbCartPreview ? 'cart-drawer-haus' : 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
